export const NAME = 'registration';